import { faFileDownload, faFileExcel, faFileUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as autobind from 'autobind';
import moment from 'moment';
import React from 'react';
import { resolve } from 'inversify.config';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'redux-scaffolding-ts';
import { Message, Icon, Grid, Button, Dimmer, Loader, Popup, Menu } from 'semantic-ui-react';
// import { InstructorVisaDto } from 'stores/skills/instructor-visa-store';
// import { nameof } from 'utils/object';
// import { TextBoxFilter } from 'widgets/collections/table-filters/textbox-filter';

import { ToastComponent } from 'site/pages/landing-pages/util/toast-component';
import {
  DownloadInstructorVisaRestrictionStore,
  InstructorVisaRestrictionDto,
  InstructorVisaRestrictionStore,
  UploadInstructorVisaRestrictionStore
} from 'stores/configuration/planner-assistant/instructor-visa-restriction-store';
import { OrderDefinition, Query } from 'stores/dataStore';
import { TableModel, TableView } from 'widgets/collections/table';
import ChangeInstructorVisaRestrictionView from './edit-instructor-visa-restriction';
import { IdentityService } from 'services/identity-service';
import { FileInfo } from 'stores/types';
import { DropDownLocationsStore, LocationDto } from 'stores/configuration/locations/locations-store';
import { VisaDto, VisaStore } from 'stores/configuration/planner-assistant/visas-store';
import { ContractDto, ContractStore } from 'stores/configuration/planner-assistant/contracts-store';
import { InstructorDto, InstructorStore } from 'stores/instructors/instructors-store';
import { FlightCostDto, FlightCostStore } from 'stores/configuration/planner-assistant/flight-costs-store';
import { DataStoreFilter } from 'widgets/collections/table-filters/data-store-filter';

export interface InstructorVisaRestrictionListProps extends WithTranslation, RouteComponentProps {
  instructorVisaRestriction: InstructorVisaRestrictionStore;
  downloadInstructorVisaRestriction?: DownloadInstructorVisaRestrictionStore;
  uploadInstructorVisaRestriction?: UploadInstructorVisaRestrictionStore;
}

export interface InstructorVisaRestrictionListState {
  query: Query;
  changeInstructorVisaRestrictionShown: boolean;
  activeFilters: string[];
  selectedItem: any;
  showDownloadMsg: boolean;
  uploadMenuOpen: boolean;
  showUploadMsg: boolean;
  uploadLoadingMessage: string;
}

@connect(
  ['instructorVisaRestriction', InstructorVisaRestrictionStore],
  ['downloadInstructorVisaRestriction', DownloadInstructorVisaRestrictionStore],
  ['uploadInstructorVisaRestriction', UploadInstructorVisaRestrictionStore],
  ['locationsStore', DropDownLocationsStore],
  ['visasStore', VisaStore],
  ['contractStore', ContractStore],
  ['flightCostStore', FlightCostStore],
  ['instructorStore', InstructorStore]
)
class InstructorVisaRestrictionListPage extends React.Component<
  InstructorVisaRestrictionListProps & {
    locationsStore: DropDownLocationsStore;
    visasStore: VisaStore;
    contractStore: ContractStore;
    flightCostStore: FlightCostStore;
    instructorStore: InstructorStore;
  },
  InstructorVisaRestrictionListState
> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  constructor(props) {
    super(props);
    this.state = {
      query: { searchQuery: '', orderBy: [{ direction: 'Descending', field: 'createdOn', useProfile: false }], skip: 0, take: 10 },
      changeInstructorVisaRestrictionShown: false,
      activeFilters: [],
      selectedItem: null,
      showDownloadMsg: false,
      uploadMenuOpen: false,
      showUploadMsg: false,
      uploadLoadingMessage: ''
    };
  }

  componentDidMount() {
    this.load();
  }

  @autobind
  private load() {
    this.props.instructorVisaRestriction.getAllAsync(this.state.query);
  }

  @autobind
  private onEditItem() {
    this.setState({ changeInstructorVisaRestrictionShown: true });
  }

  @autobind
  private onEditItemClosed(isSuccess: boolean) {
    this.setState({ changeInstructorVisaRestrictionShown: false });
    if (isSuccess) this.load();
  }

  private getDateWithOutTimeZone = (date: Date) => {
    const myFormat = 'YYYY-MM-DD';
    return moment(date, 'YYYYMMDDTHHmmss')
      .format(myFormat)
      .split('-');
  };

  @autobind
  private handlePageChange(skip: number, take: number) {
    this.setState({ query: Object.assign(this.state.query, { skip, take }) }, () => {
      this.load();
    });
  }

  private handleFilterChange = (filters: { id: string; filter: any }[]) => {
    const filter = filters.map(f => f.filter);
    const activeFilters = filters.map(f => f.id);

    const query = Object.assign(this.state.query, { filter, skip: 0 });
    this.setState({ query, activeFilters }, () => this.load());
  };

  private handleOrderBy = (newOrder: OrderDefinition[]) => {
    const orderBy: OrderDefinition[] = [...newOrder, { direction: 'Descending', field: 'createdOn', useProfile: false }];
    this.setState(({ query }) => ({ query: { ...query, orderBy } }), this.load);
  };

  private initExportInstructorVisaRestrictionProcess = () => {
    this.setState({ showDownloadMsg: true });
    this.props.downloadInstructorVisaRestriction.initBackgroundDownload();
  };

  private handleDownloadMsgDismiss = () => {
    this.setState({ showDownloadMsg: false });
  };

  private handleUploadMsgDismiss = () => {
    this.setState({ showUploadMsg: false });
  };

  private getBackgroundDownloadMessage = () => {
    const { isBusy, result } = this.props.downloadInstructorVisaRestriction.state;
    const { t } = this.props;
    if (isBusy || result == null) return null;
    let header = '';
    let content = '';
    if (!result.isSuccess) {
      header = t('Something went wrong');
      content = (result.messages || []).map(x => x.body).join('. ');
    } else {
      header = t('Background process initialized successfully');
      content = t('You will receive an email when the process ends');
    }

    return (
      <Grid.Row className="event-types-list-error-row">
        <Message
          className={!result.isSuccess && 'error-message__style'}
          icon={!result.isSuccess && 'exclamation circle'}
          onDismiss={this.handleDownloadMsgDismiss}
          header={header}
          content={content}
          error={!result.isSuccess}
          success={result.isSuccess}
        />
      </Grid.Row>
    );
  };

  private getBackgroundUploadMessage = () => {
    const { isBusy, result } = this.props.uploadInstructorVisaRestriction.state;
    const { t } = this.props;
    if (isBusy || result == null) return null;
    let header = '';
    let content = '';
    let error = false;
    if (result.error || (result.response && !result.response.isSuccessful)) {
      header = t('Something went wrong with the file');
      content = (result.error || {}).message;
      error = true;
    } else if (result.error == null && result.response && result.response.isSuccessful) {
      header = t('File uploaded successfully');
      content = t('You will receive an email when the process ends');
      error = false;
    } else return null;

    return (
      <Grid.Row className="event-types-list-error-row">
        <Message
          className={error && 'error-message__style'}
          icon={error && 'exclamation circle'}
          onDismiss={this.handleUploadMsgDismiss}
          header={header}
          content={content}
          error={error}
          success={!error}
        />
      </Grid.Row>
    );
  };

  private downloadTemplate = () => {
    const { t } = this.props;
    this.props.uploadInstructorVisaRestriction
      .downloadTemplate()
      .then(() => {
        ToastComponent({ text: t('File download successfully!'), type: 'success-toast' });
      })
      .catch(error => {
        console.error(error);
        ToastComponent({ text: t('File download failed'), type: 'error-toast' });
      });

    this.setState({ uploadMenuOpen: false, showUploadMsg: true, uploadLoadingMessage: t('Downloading the file') });
  };

  private onUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    let file: File;
    if (event?.target?.files?.length) file = event.target.files[0];
    else return;

    const { t } = this.props;
    this.setState({ showUploadMsg: true, uploadMenuOpen: false, uploadLoadingMessage: t('Queuing file for import background process') });
    const usr = this.identityService.getUserInfo();
    const fileInfo: FileInfo = {
      fileName: file.name,
      fileSize: file.size,
      content: file,
      userId: usr.userId,
      userName: usr.userName
    };

    this.props.uploadInstructorVisaRestriction
      .uploadFile(fileInfo)
      .then(res => {
        res.data.isSuccess
          ? ToastComponent({ text: t('File has been uploaded. Merging the list is in progress'), type: 'success-toast' })
          : ToastComponent({ text: t('File uploaded failed'), type: 'error-toast' });
      })
      .catch(error => {
        console.error(error);
        ToastComponent({ text: t('File uploaded failed'), type: 'error-toast' });
      });
  };

  public render() {
    const { t } = this.props as any;
    const { activeFilters } = this.state;

    const tableModel: TableModel<InstructorVisaRestrictionDto> = {
      columns: [
        {
          title: t('Instructor'),
          renderer: data => <span>{data.instructorVisa.instructor}</span>,
          tooltipRenderer: true,
          selectableHeader: true,
          headerRenderer: (title, onFilter, onClear) => (
            <DataStoreFilter<InstructorDto>
              filterTitle={t('Filter by Instructor')}
              triggerTitle={title}
              multiple={true}
              active={activeFilters.includes('instructorVisa/instructorId')}
              onFilter={(values: string[]) =>
                onFilter('instructorVisa/instructorId', {
                  instructorVisa: {
                    instructorId: {
                      in: {
                        type: 'guid',
                        value: values
                      }
                    }
                  }
                })
              }
              onClear={() => onClear('instructorVisa/instructorId')}
              getItems={q => this.props.instructorStore.getAllAsync({ ...q, take: 1000 })}
              valueSelector={item => item.userId}
              titleSelector={item => `${item.name} ${item.surname}`}
              orderBy={[{ direction: 'Ascending', field: 'name', useProfile: false }]}
              parameters=""
            />
          ),
          sortDefinition: {
            field: 'instructorVisa/instructor',
            useProfile: false
          }
        },
        {
          title: t('TTC Location'),
          renderer: data => <span>{data.instructorVisa.ttcLocationName}</span>,
          tooltipRenderer: true,
          selectableHeader: true,
          headerRenderer: (title, onFilter, onClear) => (
            <DataStoreFilter<LocationDto>
              filterTitle={t('Filter by TTC Location')}
              triggerTitle={title}
              multiple={true}
              active={activeFilters.includes('ttcLocationId')}
              onFilter={(values: string[]) =>
                onFilter('ttcLocationId', { instructorVisa: { ttcLocationId: { in: { type: 'guid', value: values } } } })
              }
              onClear={() => onClear('ttcLocationId')}
              getItems={q => this.props.locationsStore.getAllAsync({ ...q, take: 1000 })}
              valueSelector={item => item.id}
              titleSelector={item => item.location}
              orderBy={[{ direction: 'Ascending', field: 'location', useProfile: false }]}
              parameters=""
            />
          ),
          sortDefinition: { field: 'instructorVisa/ttcLocationName', useProfile: false }
        },
        {
          title: t('Traveling Location'),
          renderer: data => <span>{data.instructorVisa.travelingLocationName}</span>,
          tooltipRenderer: true,
          selectableHeader: true,
          headerRenderer: (title, onFilter, onClear) => (
            <DataStoreFilter<LocationDto>
              filterTitle={t('Filter by Traveling Location')}
              triggerTitle={title}
              multiple={true}
              active={activeFilters.includes('instructorVisa/travelingLocationId')}
              onFilter={(values: string[]) =>
                onFilter('instructorVisa/travelingLocationId', {
                  instructorVisa: { travelingLocationId: { in: { type: 'guid', value: values } } }
                })
              }
              onClear={() => onClear('instructorVisa/travelingLocationId')}
              getItems={q => this.props.locationsStore.getAllAsync({ ...q, take: 1000 })}
              valueSelector={item => item.id}
              titleSelector={item => item.location}
              orderBy={[{ direction: 'Ascending', field: 'location', useProfile: false }]}
              parameters=""
            />
          ),
          sortDefinition: { field: 'instructorVisa/travelingLocationName', useProfile: false }
        },
        {
          title: t('Start Date'),
          renderer: data => {
            if (data.instructorVisa.startDate) {
              const date = this.getDateWithOutTimeZone(new Date(data.instructorVisa.startDate));
              return <span>{`${date[2]}/${date[1]}/${date[0]}`}</span>;
            }
          },
          tooltipRenderer: true,
          sortDefinition: { field: 'instructorVisa/startDate', useProfile: false }
        },
        {
          title: t('Expire Date'),
          renderer: data => {
            if (data.instructorVisa.expireDate) {
              const date = this.getDateWithOutTimeZone(new Date(data.instructorVisa.expireDate));
              return <span>{`${date[2]}/${date[1]}/${date[0]}`}</span>;
            }
          },
          tooltipRenderer: true,
          sortDefinition: { field: 'instructorVisa/expireDate', useProfile: false }
        },
        {
          title: t('Instructor Restriction'),
          tooltipRenderer: false,
          renderer: data => <span>{!!data.instructorVisa.isInstructorRestriction ? t('Yes') : t('No')}</span>
        },
        {
          title: t('Instructor Comments'),
          tooltipRenderer: false,
          renderer: data => <span>{data.instructorVisa.instructorComments}</span>
        },
        {
          title: t('Visa application. Months duration'),
          tooltipRenderer: false,
          renderer: data => <span>{data.restriction.visaApplicationDuration}</span>
        },
        {
          title: t('Visa Requirement'),
          renderer: data => <span>{data.instructorVisa.visaName}</span>,
          tooltipRenderer: true,
          selectableHeader: true,
          headerRenderer: (title, onFilter, onClear) => (
            <DataStoreFilter<VisaDto>
              filterTitle={t('Filter by Visa')}
              triggerTitle={title}
              multiple={true}
              active={activeFilters.includes('instructorVisa/visaId')}
              onFilter={(values: string[]) =>
                onFilter('instructorVisa/visaId', { instructorVisa: { visaId: { in: { type: 'guid', value: values } } } })
              }
              onClear={() => onClear('instructorVisa/visaId')}
              getItems={q => this.props.visasStore.getAllAsync({ ...q, take: 1000 })}
              valueSelector={item => item.id}
              titleSelector={item => item.name}
              orderBy={[{ direction: 'Ascending', field: 'name', useProfile: false }]}
              parameters=""
            />
          ),
          sortDefinition: { field: 'instructorVisa/visaName', useProfile: false }
        },
        {
          title: t('Visa Restriction'),
          tooltipRenderer: false,
          renderer: data => <span>{!!data.restriction.isRestriction ? t('Yes') : t('No')}</span>
        },
        {
          title: t('Restriction Comments'),
          tooltipRenderer: false,
          renderer: data => <span>{data.restriction.comments}</span>
        },
        {
          title: t('Contract'),
          renderer: data => <span>{data.restriction.contractName}</span>,
          tooltipRenderer: true,
          selectableHeader: true,
          headerRenderer: (title, onFilter, onClear) => (
            <DataStoreFilter<ContractDto>
              filterTitle={t('Filter by Contract')}
              triggerTitle={title}
              multiple={true}
              active={activeFilters.includes('restriction/contractId')}
              onFilter={(values: string[]) =>
                onFilter('restriction/contractId', { restriction: { contractId: { in: { type: 'guid', value: values } } } })
              }
              onClear={() => onClear('restriction/contractId')}
              getItems={q => this.props.contractStore.getAllAsync({ ...q, take: 1000 })}
              valueSelector={item => item.id}
              titleSelector={item => item.name}
              orderBy={[{ direction: 'Ascending', field: 'name', useProfile: false }]}
              parameters=""
            />
          ),
          sortDefinition: { field: 'restriction/contractName', useProfile: false }
        },
        {
          title: t('Flight Cost'),
          renderer: data => <span>{data.restriction.flightCostName}</span>,
          tooltipRenderer: true,
          selectableHeader: true,
          headerRenderer: (title, onFilter, onClear) => (
            <DataStoreFilter<FlightCostDto>
              filterTitle={t('Filter by Flight Cost')}
              triggerTitle={title}
              multiple={true}
              active={activeFilters.includes('restriction/flightCostId')}
              onFilter={(values: string[]) =>
                onFilter('restriction/flightCostId', { restriction: { flightCostId: { in: { type: 'guid', value: values } } } })
              }
              onClear={() => onClear('restriction/flightCostId')}
              getItems={q => this.props.flightCostStore.getAllAsync({ ...q, take: 1000 })}
              valueSelector={item => item.id}
              titleSelector={item => item.name}
              orderBy={[{ direction: 'Ascending', field: 'name', useProfile: false }]}
              parameters=""
            />
          ),
          sortDefinition: { field: 'restriction/flightCostName', useProfile: false }
        }
      ],
      data: this.props.instructorVisaRestriction.state
    };

    return (
      <>
        <Grid className="event-types-list-grid">
          {this.state.showUploadMsg && this.getBackgroundUploadMessage()}
          {this.props.downloadInstructorVisaRestriction.state.isBusy && (
            <Dimmer active style={{ zIndex: 999, background: 'rgba(0, 0, 0, 0.4)' }}>
              <Loader indeterminate>{t('Initializing download background process')}</Loader>
            </Dimmer>
          )}
          {this.state.showDownloadMsg && this.getBackgroundDownloadMessage()}
          {this.props.instructorVisaRestriction.state.result && !this.props.instructorVisaRestriction.state.result.isSuccess && (
            <Grid.Row className="event-types-list-error-row">
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.props.instructorVisaRestriction.state.result.messages.map(o => o.body)}
              />
            </Grid.Row>
          )}

          <Grid.Row className="event-types-list-items-row request-list__table-view">
            <TableView
              selectable={false}
              maxSelection={1}
              onHideCheckbox={true}
              selectionType={'allRow'}
              model={tableModel}
              extraActions={[
                {
                  content: (
                    <>
                      <Icon name="pencil alternate" />
                      &nbsp;{t('Edit')}
                    </>
                  ),
                  onClick: item => {
                    this.setState({ selectedItem: item }, this.onEditItem);
                  }
                }
              ]}
              extraMenu={[
                {
                  className: 'menu-item-download',
                  content: (
                    <Popup
                      on="click"
                      position="bottom center"
                      open={this.state.uploadMenuOpen}
                      onOpen={() => this.setState({ uploadMenuOpen: true })}
                      onClose={() => this.setState({ uploadMenuOpen: false })}
                      trigger={
                        <Button
                          icon
                          size="mini"
                          className="custom-table-upload-btn custom-table-upload-btn__up-down transparent-btn"
                          onClick={() => this.setState({ uploadMenuOpen: true })}
                          data-tooltip={t('Import')}
                        >
                          <FontAwesomeIcon className="solid" icon={faFileUpload} size="lg" />
                        </Button>
                      }
                    >
                      <Menu vertical secondary>
                        <Menu.Item key="upload" position="left" as="label" htmlFor="file" className="turquose-onhover">
                          <FontAwesomeIcon className="solid float-right" icon={faFileUpload} size="lg" />
                          <input type="file" id="file" style={{ display: 'none' }} onChange={this.onUpload} />
                          &nbsp;{t('Upload File')}
                        </Menu.Item>

                        <Menu.Item className="turquose-onhover" key="template" position="left" onClick={this.downloadTemplate}>
                          <FontAwesomeIcon className="solid float-right" icon={faFileExcel} size="lg" />
                          &nbsp;{t('Download Template')}
                        </Menu.Item>
                      </Menu>
                    </Popup>
                  )
                },
                {
                  className: 'menu-item-download',
                  content: (
                    <Button
                      icon
                      size="medium"
                      onClick={this.initExportInstructorVisaRestrictionProcess}
                      className="custom-table-upload-btn black-btn"
                      data-tooltip={t('Export')}
                    >
                      <FontAwesomeIcon className="solid" icon={faFileDownload} size="lg" />
                    </Button>
                  )
                }
              ]}
              onRefresh={this.load}
              canEdit={false}
              canDelete={false}
              onPageChange={this.handlePageChange}
              onFilterChange={this.handleFilterChange}
              onOrderByChanged={this.handleOrderBy}
            />
          </Grid.Row>
        </Grid>
        {this.state.changeInstructorVisaRestrictionShown && (
          <ChangeInstructorVisaRestrictionView onClose={this.onEditItemClosed} currentInstructorVisaRestriction={this.state.selectedItem} />
        )}
      </>
    );
  }
}

export default withTranslation()(InstructorVisaRestrictionListPage);
